<template>
  <div>
    <v-card class="rounded-lg pa-2" elevation="2">
      <v-row class="d-flex justify-start pa-2 mb-1 mt-3" dense>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="rounded-lg"
              elevation="0"
              color="#f5f7f5"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="mr-2" color="#6a7c6e">mdi-filter</v-icon>
              <span style="color: #6a7c6e">{{$t('buttons.filter')}}</span>
            </v-btn>
          </template>

          <v-card class="rounded-lg">
            <v-list dense class="text-center w-full text-xs font-medium">
              <span>Selecione os Filtros</span>
            </v-list>

            <v-form @submit.prevent="getLogsData" ref="form">
              <div class="overflow-y-auto gap-0 flex-1">
                <v-list>
                  <v-list-item>
                    <v-text-field
                      color="#086318"
                      label="Data Inicial"
                      class="rounded-lg"
                      type="date"
                      @input="onlyDateInput('filter' ,'date_initial' , $event)"
                      :max="maxDate"
                      hide-details
                      outlined
                      v-model="filter.date_initial"
                      dense
                    >
                    </v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-text-field
                      color="#086318"
                      label="Data Final"
                      class="rounded-lg"
                      type="date"
                      @input="onlyDateInput('filter' ,'date_final' , $event)"
                      :max="maxDate"
                      hide-details
                      outlined
                      v-model="filter.date_final"
                      dense
                    >
                    </v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-autocomplete
                      :items="unities"
                      item-value="hospital"
                      item-text="hospital"
                      color="#086318"
                      label="Unidades de Saúde"
                      class="rounded-lg"
                      hide-details
                      outlined
                      v-model="filter.hospital"
                      dense
                    >
                    </v-autocomplete>
                  </v-list-item>
                  <v-list-item>
                    <v-text-field
                      color="#086318"
                      label="Usuário(CPF)"
                      hide-details
                      class="rounded-lg"
                      outlined
                      v-model="filter.cpf"
                      v-mask="'###.###.###-##'"
                      dense
                    >
                    </v-text-field>
                  </v-list-item>
                </v-list>
              </div>

              <v-card-actions class="justify-center">
                <v-btn class="rounded-lg" @click="menu = false" small>
                  {{$t('buttons.cancel')}}
                </v-btn>
                <v-btn
                  small
                  color="#aab5b0"
                  class="rounded-lg"
                  :loading="loadingTrashButton"
                  @click="clear()"
                  dark
                >
                  {{$t('buttons.clean_up')}}
                </v-btn>
                <v-btn
                  class="rounded-lg"
                  color="#41916b"
                  small
                  dark
                  :loading="loadingBTN"
                  @click="applyFilters()"
                >
                  <v-icon color="#FFFFFF">mdi-magnify</v-icon>
                  {{$t('buttons.search')}}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-menu>
      </v-row>

      <v-data-table
        :items="items"
        :options.sync="options"
        :headers="headers"
        :page-count="numberOfPages"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15],
          itemsPerPageText: 'Itens por Página',
        }"
      >
        <template #no-data>
          <div class="text-center py-4">{{ $t('messages.no_records_found')}}</div>
        </template>

        <template v-slot:item.usuario="{ item }">
          <span v-if="item.user">{{
            item.user.name + " (" + item.user.cpf + ")"
          }}</span>
        </template>
        <template v-slot:item.dateAndHour="{ item }">
          <span v-if="item.created_at">{{ formatData(item.created_at) }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { getLogs, getUnities } from "@/service/LogsService";
import dateTimeLimit from "../../utils/dateTimeLimit";
export default {
  data: () => ({
    headers: [
      {
        text: "Data/Hora da alteração",
        align: "start",
        value: "dateAndHour",
      },
      {
        text: "Nome Usuário",
        align: "start",
        sortable: false,
        value: "usuario",
      },
      { text: "Perfil", value: "user.profile.name" },
      { text: "Unidade de Saúde", value: "user.unity.hospital" },
      { text: "Funcionalidade", value: "event" },
    ],
    atualDateAndHour: new Date().toLocaleString(),
    logForm: {},
    filter: {},
    menu: false,
    patienteMe: 0,
    patientePCR: 0,
    finishedTransplants: 0,
    pendingTransplants: 0,
    loadingBTN: false,
    loadingTrashButton: false,
    funcionalities: [
      { value: "created", text: "Cadastrou" },
      { value: "updated", text: "Alterou" },
      { value: "deleted", text: "Excluiu" },
      { value: "restore", text: "Restaurou" },
    ],
    items: [],
    page: 1,
    numberOfPages: 0,
    search: "",
    options: {},
    unities: [],
    totalItems: "",
  }),

  async created() {
    this.loading = true;

    this.getLogsData();
    this.unities = await getUnities();
  },

  computed: {
    maxDate() {
      const now = new Date()
      return now.toISOString().slice(0, 10)
    } 
  },

  watch: {
    search() {
      this.getLogsData();
    },

    options: {
      handler() {
        this.getLogsData();
      },
      deep: true,
    },
  },

  methods: { 
    applyFilters() {
      this.getLogsData(),
      this.loadingBTN = true, 
      this.loading = true
    },
    
    onlyDateInput(path,field, value) {  
       this[path][field] =
        dateTimeLimit.limiteInputOnlyDate(value)
    },
    async clear() {
      this.filter = {};
      this.loadingTrashButton = false;
      this.getLogsData();
    },

    formatData(data) {
      return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },

    async getLogsData() {
      const { page, itemsPerPage } = this.options;

      let items = {};

      this.loading = true;
      this.loadingTrashButton = true;

      items = await getLogs(this.filter, page, itemsPerPage);

      this.items = items.data;
      this.totalItems = items.total;
      this.numberOfPages = items.last_page;
      this.loading = false;
      this.loadingTrashButton = false;
      this.loadingBTN = false;
    },
  },
};
</script>
